<template>
  <div  class="info">
    <div class="info__container info__content info__content-padding">
        <h2>Інформація</h2>
        <div class="info__content__text">
        <p><b>Організація</b> діє відповідно до Конституції України, Цивільного 
            та Податкового кодексів України, Закону України «Про громадські 
            об'єднання» та інших нормативних актів. Основні принципи діяльності: 
            добровільність, самоврядність, прозорість, відкритість та публічність.
             Організація не є підприємницькою і не має на меті отримання прибутку.</p>
                <p>Наш логотип — це зображення гілки бузини з чорними ягодами та зеленим листям 
                на тлі листка блакитної конюшини з написом "Громадська організація Виробників 
                Лікарських Трав та Рослин України".</p>
                <p><b>Основна мета діяльності</b> — об'єднання зусиль усіх зацікавлених осіб для захисту 
                    прав та інтересів членів Організації, координація виробництва та реалізації лікарських 
                    трав і рослин, популяризація їх споживання, забезпечення екологічної безпеки та збереження 
                    природних ресурсів.</p>
                    <p><b>Організація активно сприяє</b> створенню громадських об'єднань виробників лікарських трав та 
                        рослин у територіальних громадах, формуючи нові осередки для залучення максимальної 
                        кількості учасників. Ми створюємо сприятливі умови для реалізації продукції як на 
                        внутрішньому ринку, так і за його межами, допомагаємо у просуванні продукції та 
                        сприяємо обміну знаннями та досвідом серед членів Організації. Спільно з науковими 
                        та державними інституціями, визначаємо єдині напрями розвитку галузі, підтримуємо 
                        професійний розвиток виробників та надаємо консультаційну, інформаційну, правову, 
                        маркетингову та рекламну підтримку.</p>
                        <p><b>Асоціація узагальнює та поширює</b> кращі практики у галузі виробництва 
                            та переробки лікарських трав, впроваджуючи нові науково-технічні 
                            розробки та методики. Ми створюємо сприятливий інвестиційний клімат для 
                            спеціалізованих підприємств, сприяємо отриманню кредитів та залученню інвестицій 
                            на пільгових умовах, розробляємо та впроваджуємо програми для якісного зберігання 
                            лікарських рослин, страхування посівів та моніторингу дотримання екологічних норм.</p>
                            <p><b>Організація активно співпрацює</b> з науковими установами для покращення бази лікарських рослин, 
                                розвиває міжнародне співробітництво шляхом обміну делегаціями та досвідом з іншими країнами, 
                                організовує наукові та практичні конференції, виставки, круглі столи та тематичні конкурси. 
                                Ми набуваємо майнові та немайнові права, укладаємо угоди з резидентами та нерезидентами 
                                України, організовуємо заходи для реалізації статутних завдань, створюємо відокремлені 
                                підрозділи для виконання статутних завдань. Поширюємо знання щодо використання лікарських 
                                трав, популяризуємо органічне вирощування та сприяємо отриманню сертифікатів на органічну 
                                продукцію, а також розвиток зеленого туризму в Україні.</p>
                                <p><b>Організація сприяє збереженню,</b> розвитку та популяризації українського села, збагачуючи його культурну спадщину. 
                                    Ми надаємо повний супровід для експорту українських трав до Європи, забезпечуючи консультаційну, 
                                    інформаційну, правову, маркетингову та рекламну допомогу.</p>
                                    <p><b>Асоціація Виробників Лікарських Трав та Рослин України</b> — це об'єднання, яке працює на благо нашої землі та майбутніх поколінь</p>
            </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style>

</style>